class OgerStickyPurchase extends HTMLElement {
  connectedCallback() {
    this.control = this.querySelector('[data-oger-sticky-add]');
    this.price = this.querySelector('[data-oger-sticky-price]');
    this.root = document.querySelector('.product-information');
    if (!this.root || !this.control) return;
    this.onClick = () => {
      const source = this.root.querySelector('.buy-buttons-block button[name="add"]');
      if (!source || source.disabled) return;
      const fields = source.closest('form')?.querySelector('.oger-chef-fields');
      if (fields) {
        fields.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        fields.querySelector('textarea')?.focus({ preventScroll: true });
        return;
      }
      source.click();
    };
    this.sync = () => {
      const source = this.root.querySelector('.buy-buttons-block button[name="add"]');
      if (!source) { this.hidden = true; return; }
      if (source !== this.source) {
        this.source = source;
        this.intersection?.disconnect();
        this.intersection = new IntersectionObserver(entries => {
          this.hidden = entries[0].isIntersecting;
        });
        this.intersection.observe(source);
      }
      this.control.disabled = source.disabled || source.getAttribute('aria-busy') === 'true';
      const custom = source.closest('form')?.querySelector('.oger-chef-fields');
      const label = custom && !source.disabled ? this.dataset.customLabel : source.querySelector('.add-to-cart-text__content')?.textContent.trim();
      if (label && this.control.textContent !== label) this.control.textContent = label;
      const price = this.root.querySelector('product-price .price')?.textContent.trim();
      if (price && this.price.textContent !== price) this.price.textContent = price;
    };
    this.schedule = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
    };
    this.control.addEventListener('click', this.onClick);
    this.mutation = new MutationObserver(this.schedule);
    this.mutation.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    this.sync();
  }
  disconnectedCallback() {
    this.intersection?.disconnect();
    this.mutation?.disconnect();
    cancelAnimationFrame(this.frame);
    this.control?.removeEventListener('click', this.onClick);
  }
}
if (!customElements.get('oger-sticky-purchase')) customElements.define('oger-sticky-purchase', OgerStickyPurchase);
